/* eslint-disable react/display-name */
import React from '../../_snowpack/pkg/react.js';
import { useQuery } from '../../_snowpack/pkg/@apollo/react-hooks.js';
import { GET_TENANT_AUTHENTICATION_METHOD } from '../queries/index.js';
import useTenant from './useTenant.js';

function useTenantAuthMethod() {
  var _data$tenant$get, _data$tenant;

  const {
    tenant: {
      id,
      identifier
    }
  } = useTenant();
  const {
    error,
    data,
    loading
  } = useQuery(GET_TENANT_AUTHENTICATION_METHOD, {
    variables: {
      tenantId: id,
      identifier
    }
  });
  const {
    authenticationMethod,
    staticAuthToken
  } = (_data$tenant$get = data === null || data === void 0 ? void 0 : (_data$tenant = data.tenant) === null || _data$tenant === void 0 ? void 0 : _data$tenant.get) !== null && _data$tenant$get !== void 0 ? _data$tenant$get : {};

  if (error) {
    console.error('Could not retrieve tenant authentication method', error);
    return {};
  }

  if (loading) {
    return {};
  }

  return {
    authenticationMethod,
    staticAuthToken
  };
}

export default useTenantAuthMethod; // eslint-disable-next-line @typescript-eslint/no-explicit-any

export const withTenantAuthMethod = Component => props => {
  const {
    authenticationMethod,
    staticAuthToken
  } = useTenantAuthMethod();
  const composedProps = { ...props,
    authenticationMethod,
    staticAuthToken
  };

  if (authenticationMethod === undefined && staticAuthToken === undefined) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Component, composedProps);
};